export default __webpack_public_path__ + "aa62e8c3fe276ceb7eef43b207cd9679.png";